import { Locale, type LocalizedString } from "../Locale.js";
import { homepagePathMap } from "./homepagePathMap.js";
import { prefixPath } from "./prefixPath.js";

export function localizePathMap(pathMap: LocalizedString): LocalizedString {
	return Object.fromEntries(
		Object.values(Locale).map((locale) => [locale, prefixPath(homepagePathMap[locale], pathMap[locale])]),
	) as LocalizedString;
}
